import NameTranslation from "../../model/translations/NameTranslation";
import { formatBooleanValue } from "../../../util";

const NameTranslationMapper = (item: any) => {
  let nameTranslation = NameTranslation(item);
  nameTranslation.valid = formatBooleanValue(item.valid);

  return nameTranslation;
};

export default NameTranslationMapper;
